/*
  * useWindowDimensions
  A react hook to easily calculate and listen to viewport size changes
  Credits: https://usehooks.com/useWindowSize/

  * To Use:
  import useWindowDimensions from '.../useWindowDimensions'
  const dimensions = useWindowDimensions();
  const { height, width } = dimensions;
*/

import { useState, useEffect } from 'react';

const useWindowDimensions = () => {
  const isClient = typeof window === 'object';

  function getSize() {
    return {
      width: isClient ? window.innerWidth : undefined,
      height: isClient ? window.innerHeight : undefined,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(getSize);

  useEffect(() => {
    if (!isClient) {
      return false;
    }

    function handleResize() {
      setWindowDimensions(getSize());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []); // Empty array ensures that effect is only run on mount and unmount

  return windowDimensions;
};

export default useWindowDimensions;
